import React from 'react'
import VoiceHero from './VoiceHero'
import StatsBar from './StatsBar'
import HumanLikeVoiceEngine from './HumanLikeVoiceEngine'
import VoiceCapabilities from './VoiceCapabilities'
import VoiceAIUseCases from './VoiceAIUseCases'
import InboundOutboundVoiceAI from './InboundOutboundVoiceAI'
import WorkflowBuilder from './WorkflowBuilder'
import SeamlessIntegrations from './SeamlessIntegrations'
import BusinessCTASection from './BusinessCTASection'

function VoiceAIAgents() {
    return (
        <div>
            <VoiceHero />
            <StatsBar />
            <HumanLikeVoiceEngine />
            <VoiceCapabilities />
            <VoiceAIUseCases />
            <InboundOutboundVoiceAI />
            <WorkflowBuilder />
            <SeamlessIntegrations />
            <BusinessCTASection />
        </div>
    )
}

export default VoiceAIAgents
